export default "__VITE_ASSET__B69_V2eC__"